import { StateCreator, StoreApi } from 'zustand';

export type StripeModalReportInfo = {
  module?: string; // 支付来源
  product_name?: string; // 支付产品名称
  amount?: string; // 支付金额
  transaction_id?: string; // 支付交易id
  user_id?: string; // 用户id
  email?: string; // 用户邮箱
};

type StripeModalContext = {
  clientSecret: string;
  reportInfo: StripeModalReportInfo;
  paymentSuccessCallback?: () => void;
};

const initialState = {
  isStripeModalOpen: false,
  stripeModalContext: {} as StripeModalContext,
};

type StripeModalState = typeof initialState;

type StripeModalAction = {
  setStripeModalOpen: (open: boolean, context: StripeModalContext) => void;
};

export type StripeModalStore = StripeModalState & StripeModalAction;

const stripeModalActions = (
  set: StoreApi<StripeModalStore>['setState'],
  get: StoreApi<StripeModalStore>['getState'],
  api: StoreApi<StripeModalStore>
): StripeModalAction => ({
  setStripeModalOpen: (open: boolean, context) =>
    set({ isStripeModalOpen: open, stripeModalContext: context }),
});

export const useStripeModalStore: StateCreator<StripeModalStore> = (
  set,
  get,
  api
) => ({
  ...initialState,
  ...stripeModalActions(set, get, api),
});
